/// <amd-module name="Search/Package/Utils" />

import { PackageSearchRequest } from "Search/WebApi/Contracts/Search.Shared";
import { areFiltersEqual } from "Search/Shared/Utils";


export function areQueriesSame(left: PackageSearchRequest, right: PackageSearchRequest): boolean {
    if (left.searchText !== right.searchText) {
        return false;
    }

    if (left.$top !== right.$top) {
        return false;
    }

    return areFiltersEqual(left.filters, right.filters);
}